const hasMeaningfulContent = (text) => {
  // Remove non-word characters and split by spaces
  const meaningfulWords = text
    .replace(/[^\w\s]/g, '')
    .trim()
    .split(/\s+/)

  // Check for minimum length and number of unique words
  if (meaningfulWords.length < 5) return false

  const uniqueWords = new Set(meaningfulWords)

  // Check if the number of unique words is less than a threshold
  if (uniqueWords.size < 3) return false

  // Check for presence of common meaningful keywords
  const meaningfulKeywords = ['name', 'date', 'relationship', 'birth', 'death', 'marriage']
  const containsKeywords = meaningfulKeywords.some((keyword) => text.toLowerCase().includes(keyword))

  return containsKeywords || meaningfulWords.length > 5
}

export default hasMeaningfulContent
